/**
 * Bộ nhớ "ảnh VỪA tải lên trong phiên này": `base_path` → URL ảnh gốc.
 *
 * 🔴 Vì sao cần: worker sinh thumb/md/lg mất ~1–10 giây. Màn nào xin biến thể
 * trong khoảng đó sẽ nhận 404, mà kho gắn `Cache-Control: immutable` lên CẢ
 * 404 nên Cloudflare ghim bản 404 ấy MỘT NĂM — đo thật 25/09/2026 trên
 * cdn.gaonau.com: xin lại đúng URL đó ra `cf-cache-status: HIT`. Từ đó ảnh vỡ
 * với mọi người, mọi máy, không tự lành. Ảnh gốc có NGAY khi tải xong nên vẽ
 * bằng nó thì không bao giờ đẻ ra cái 404 để bị ghim.
 *
 * Nhớ ở tầng dùng chung chứ không ở từng màn, vì màn ĐÍCH thường không phải
 * màn vừa tải: tạo đơn xong là nhảy sang trang chi tiết đơn, trang đó xin bản
 * `md` chỉ vài giây sau. 17 chỗ trong app gọi `uploadImageToR2`, không thể bắt
 * mỗi chỗ tự truyền tay URL ảnh gốc sang màn kế.
 *
 * Tách khỏi `lib/upload.ts` CỐ Ý: nhiều bài kiểm giả lập nguyên module đó để
 * chặn đường mạng, mà mock chỉ khai vài hàm — để hàm này nằm chung là mọi màn
 * dùng `VariantImage` đều vỡ khi chạy dưới các bài kiểm ấy.
 */

/**
 * Quá mốc này thì biến thể chắc chắn đã sinh xong: quay về dùng biến thể cho
 * nhẹ, vì ảnh gốc có thể tới 25 MB.
 */
const FRESH_UPLOAD_MS = 60_000;

const freshUploads = new Map<string, { orig: string; at: number }>();

/** Ghi nhớ ảnh vừa tải lên. Tự dọn các mục đã quá hạn. */
export function rememberFreshUpload(basePath: string, origUrl: string): void {
  if (!basePath || !origUrl) return;
  const now = Date.now();
  for (const [key, entry] of freshUploads) {
    if (now - entry.at >= FRESH_UPLOAD_MS) freshUploads.delete(key);
  }
  freshUploads.set(basePath, { orig: origUrl, at: now });
}

/** URL ảnh gốc nếu ảnh này vừa được tải lên; ngoài mốc thì trả undefined. */
export function freshOriginalUrl(basePath: string): string | undefined {
  const entry = freshUploads.get(basePath);
  if (!entry) return undefined;
  if (Date.now() - entry.at >= FRESH_UPLOAD_MS) {
    freshUploads.delete(basePath);
    return undefined;
  }
  return entry.orig;
}

/** Chỉ dùng cho bài kiểm — xoá sạch bộ nhớ ảnh vừa tải. */
export function __resetFreshUploads(): void {
  freshUploads.clear();
}
